
import React from 'react';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import Introduction from '@/components/Introduction';
import CoreFeatures from '@/components/CoreFeatures';
import Features from '@/components/Features';
import IndustrySolutions from '@/components/IndustrySolutions';
import ServicePackage from '@/components/ServicePackage';
import Testimonials from '@/components/Testimonials';
import FAQ from '@/components/FAQ';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Introduction />
      <CoreFeatures />
      <Features />
      <IndustrySolutions />
      <ServicePackage /> 
      <FAQ />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Index;
